import { mergeIconColorVars as e } from "../icon-props.js";
import { jsx as t } from "react/jsx-runtime";
//#region src/icons/underline-01.tsx
function n({ colors: n, style: r, ...i }) {
	return /* @__PURE__ */ t("svg", {
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		focusable: "false",
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			...e(n),
			...r
		},
		...i,
		children: /* @__PURE__ */ t("path", {
			d: "M20 20C20.5523 20 21 20.4477 21 21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21C3 20.4477 3.44772 20 4 20H20ZM5 11V4C5 3.44772 5.44772 3 6 3C6.55228 3 7 3.44772 7 4V11C7 13.7614 9.23858 16 12 16C14.7614 16 17 13.7614 17 11V4C17 3.44772 17.4477 3 18 3C18.5523 3 19 3.44772 19 4V11C19 14.866 15.866 18 12 18C8.13401 18 5 14.866 5 11Z",
			fill: "var(--icon-color-primary, currentColor)"
		})
	});
}
//#endregion
export { n as Underline01Icon };
